import { render } from "./Holidayedit.vue?vue&type=template&id=e349f310&ts=true"
import script from "./Holidayedit.vue?vue&type=script&lang=ts"
export * from "./Holidayedit.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__